





































































































































































import CompanyService from "@/services/companyService";
import Component from "vue-class-component";
import Header from "@/types/app/header";
import InvestorInterface, { investorInitialValue } from "@/types/app/investor";
import Vue from "vue";
import InvestorHeader from "../headers/investors-header";
import { Prop, Watch } from 'vue-property-decorator';
import applyCondition from "@/utils/applyCondition";
import BaseComponent from "@/utils/baseComponent";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import CustomerService from "@/services/customerService";
import ModalInvestorDetailAccount from "./ModalInvestorDetailAccount.vue";

@Component({
    components: { ModalInvestorDetailAccount }
})
export default class CrudInvestor extends BaseComponent {

    showInvestorAccount = false;
    loadingInvestors = false;
    investorHeaders: Header[] = InvestorHeader.header;
    investorNameFilter = '';
    @Prop() public investors!: InvestorInterface[];
    @Prop(String) public readonly companyId!: string;
    @Prop(String) public readonly companyEmail!: string;
    editedInvestor: InvestorInterface = investorInitialValue;
    companyService = new CompanyService(this.$http);
    customerService = new CustomerService(this.$http);
    dialogInvestorDelete = false;
    investorAccount: any = {};
    existsClient = 'No';
    dialogInvestor = false;
    editedInvestorIndex = -1;
    valid = false;
    useEmailCompany = false;
    customersOthers: VuetifySelectItems[] = [];
    selectedCustomers: VuetifySelectItems[] = [];

    setEmailCompany() {
        if (this.useEmailCompany) {
            this.editedInvestor.email = this.companyEmail;
        }
        else this.editedInvestor.email = '';
    }

    get formInvestorTitle() {
        return this.editedInvestorIndex === -1 ? 'New Investor' : 'Edit Investor'
    }

    async mounted() {
        await this.getCustomers();
    }

    get filteredInvestors() {
        const conditions: any[] = [];
        if (this.investorNameFilter) {
            conditions.push((item: InvestorInterface) =>
                item.name.toLowerCase().includes(this.investorNameFilter.toLowerCase())
            );
        }

        return applyCondition<InvestorInterface>(this.investors, conditions);
    }

    get likesAllCustomer() {
        return this.selectedCustomers.length === this.customersOthers.length;
    }

    get likesSomeCustomers() {
        return this.selectedCustomers.length > 0 && !this.likesAllCustomer;
    }
    get icon() {
        if (this.likesAllCustomer) return "mdi-close-box";
        if (this.likesSomeCustomers) return "mdi-minus-box";
        return "mdi-checkbox-blank-outline";
    }

    showAccounts(investor: InvestorInterface) {
        this.investorAccount = investor;
        this.showInvestorAccount = true;
    }

    toggleSelectAll() {
        this.$nextTick(() => {
            if (this.likesAllCustomer) {
                this.selectedCustomers = [];
            } else {
                this.selectedCustomers = this.customersOthers;
            }
        });
    }
    @Watch("dialogInvestor")
    async getCustomers(): Promise<void> {
        this.loadingInvestors = true;
        this.customersOthers = await this.customerService.getSelectItemsCustomers(-1);
        this.customersOthers = this.customersOthers.filter(c => this.investors.find(i => i.id == c.value) == null)
        this.loadingInvestors = false;
    }

    closeInvestorModal() {
        this.dialogInvestor = false;
        this.$nextTick(() => {
            this.editedInvestor = Object.assign({}, investorInitialValue)
            this.editedInvestorIndex = -1;
            this.selectedCustomers = [];
            this.existsClient = 'No';
            this.useEmailCompany = false;
        })

    }

    async addInvestorModal() {
        if (!this.form().validate()) {
            return false;
        }
        this.loadingInvestors = true;
        try {
            if (this.existsClient == 'No') {
                if (this.editedInvestorIndex > -1) {
                  
                    const result = await this.companyService.saveCompanyInvestor(this.companyId, this.editedInvestor.name,
                        this.editedInvestor.email, this.editedInvestor.id);
                    if (!result.hasErrors)
                    {
                        Object.assign(this.investors[this.editedInvestorIndex], this.editedInvestor);
                        this.showSuccess('Saved an investor with successfully');
                    }
                    else {
                        this.showError('An error occurred when trying to save the investor. Please try again later.');
                        return;
                    }
                } else {

                    const result = await this.companyService.saveCompanyInvestor(this.companyId, this.editedInvestor.name,
                        this.editedInvestor.email, '');
                    if (!result.hasErrors) {
                        this.editedInvestor.id = result.data;
                        this.investors.push(this.editedInvestor);
                        this.showSuccess('Created an investor with successfully');
                    } else {
                        this.showError('An error occurred when trying to save the investor. Please try again later.');
                        return;
                    }
                }
            }
            else {
                const clients = this.selectedCustomers.map(x =>
                    ({ email: x.email, id: x.value, investorId: x.value, name: x.name, updatedDate: '' })
                )

                const result = await this.companyService.saveCompanyInvestorClientUser(this.companyId, clients);

                if (!result.hasErrors) {
                    clients.forEach(element => {
                        this.investors.push(element as InvestorInterface);
                    });
                    this.showSuccess('Saved the investor with successfully');
                }
                else {
                    this.showError('An error occurred when trying to save the investor. Please try again later.');
                    return;
                }
            }

            this.closeInvestorModal();

        } finally {
            this.loadingInvestors = false;
        }

    }
    closeInvestorDelete() {
        this.dialogInvestorDelete = false
        this.$nextTick(() => {
            this.editedInvestor = Object.assign({}, investorInitialValue);
            this.editedInvestorIndex = -1
        })
    }
    async deleteInvestorConfirm() {
        this.loadingInvestors = true;
        try {
            const result = await this.companyService.deleteCompanyInvestor(this.companyId, this.editedInvestor.id);
            if (!result.hasErrors) {
                this.investors.splice(this.editedInvestorIndex, 1);
                this.closeInvestorDelete();
                this.showSuccess('Deleted the investor with successfully');
            }
            else {
                this.showError('An error occurred when trying to delete the investor. Please try again later.');
            }
        }
        finally {
            this.loadingInvestors = false;
        }
    }

    editInvestorClick(item: InvestorInterface) {

        this.editedInvestorIndex = this.investors.indexOf(item);
        this.editedInvestor = Object.assign({}, item)
        this.dialogInvestor = true
    }

    deleteInvestorClick(item: InvestorInterface) {
        this.editedInvestorIndex = this.investors.indexOf(item)
        this.editedInvestor = Object.assign({}, item)
        this.dialogInvestorDelete = true
    }
}

